import { usePaymentsStore } from '../store/paymentsStore';

export const useGatewayStats = () => {
  return usePaymentsStore((state) => state.gatewayStats);
};
